import React from 'react';
import Box from '@mui/material/Box';

export default function BigHeading(props) {
    return (
        <Box sx={{ fontSize: '3em', marginTop: '10px', ...(props.sx || {}) }}
            onClick={props.onClick}>
            {props.children}</Box>
    )
}
